import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScreenLoader from '../../components/common/ScreenLoader';
import SearchField from '../../components/common/Search';
import Table from '../../components/common/Table';
import DeletePermissionsModal from '../../components/common/modals/delete';
import { applicantsTableHeader } from '../../constants/appConstants';
import { setApplicants } from '../../redux/slice/appSlice';
import { AuthenticatedGETRequest } from '../../utils';

const Applicants = ({ createNotification }) => {
    const { applicants } = useSelector((state) => state.appReducer);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [searchedRows, setSearchedRows] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await AuthenticatedGETRequest('applicants');
                setLoading(false);
                dispatch(setApplicants(data));
                setSearchedRows(data);
            } catch (error) {
                setLoading(false);
                createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
            }
        };
        setLoading(true);
        fetchData();
        // eslint-disable-next-line
    }, [createNotification]);

    return loading ? (
        <ScreenLoader />
    ) : (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            <div className='flex justifyCenter alignCenter w-100'>
                <h2>
                    درخواست دہندگان کی مجموعی تعداد :
                    <span
                        style={{
                            fontFamily: 'CircularStd',
                            fontSize: 26,
                            marginRight: 8,
                            color: '#2196f3',
                        }}
                    >
                        {searchedRows ? searchedRows.length : 0}
                    </span>
                </h2>
            </div>

            <SearchField
                label={`فارم نمبر  یا  شناختی کارڈ اور موبائل نمبر سے تلاش کریں `}
                data={searchedRows}
                list={applicants}
                setSearchedRows={setSearchedRows}
            />
            {searchedRows && searchedRows.length > 0 ? (
                <Table
                    tableHeaders={applicantsTableHeader}
                    data={searchedRows}
                    screen='applicants'
                    link={'dashboard/applicants/detail'}
                    openDelete={(id) => {
                        setDeleteModal(true);
                        setDeleteId(id);
                    }}
                />
            ) : (
                <div className='flex justifyCenter alignCenter w-100'>
                    <h1 style={{ marginTop: 56, color: '#e91e63', fontWeight: 900 }}>
                        {searchedRows && searchedRows.length > 0
                            ? 'معذرت، اس درخواست دہندہ کا کوئی ڈیٹا موجود نہیں ہے۔'
                            : ' درخواست دہندگان کی طرف سے کوئی درخواست موصول نہیں ہوئی ہے۔'}
                    </h1>
                </div>
            )}

            <DeletePermissionsModal
                label='درخواست دہندہ کا ریکارڈ حذف کریں'
                description='کیا آپ اس درخواست دہندہ کا ریکارڈ کو مستقل طور پر حذف کرنے کا یقین رکھتے ہیں؟'
                btnText='حذف کریں'
                open={deleteModal}
                id={deleteId}
                screen='applicants'
                onError={(error) => createNotification('error-toast', error)}
                onClose={() => setDeleteModal(false)}
            />
        </div>
    );
};

export default Applicants;
